<template>
  <router-view />
</template>
<script setup>
import { provide } from 'vue'
import * as echarts from 'echarts'
provide('ec',echarts)

</script>
<style lang="scss">
#app {
  overflow-x: hidden;
  height: 100vh;
}
</style>
